<template>
  <div id="settings" class="wrrapper mb-1">
    <page-heading
      :title="branchData.branchName || 'Branch details'"
      border
      back
    />

    <div class="settings-template">
      <div class="logo_div">
        <div class="setting_logo">
          <img
            v-if="branchData.logoUrl"
            :src="branchData.logoUrl"
            alt=""
            class="logoImage"
          />
        </div>
        <div v-if="progressStatus">
          <ProgressBar v-if="uploadProgress > 1" :completed="uploadProgress" />
          <p class="text-center" v-if="uploadProgress == 100">
            Logo Uploaded ✅
          </p>
        </div>
        <Upload
          label="Change Logo"
          @update-picture="handleFileUpload"
          for="upload-photo"
          class="flex justify-center upload_button"
        />
      </div>

      <Input
        class="mb-base"
        label="Name"
        type="text"
        v-model="branchData.branchName"
      />
      <Input
        class="mb-base"
        label="Email"
        type="text"
        v-model="branchData.email"
      />
      <Input
        class="mb-base"
        label="Phone"
        type="text"
        v-model="branchData.phoneNumber"
      />

      <h2 class="bussiness-header">Header</h2>
      <TemplateEditor ref="header" height="200" />
      <h2 class="bussiness-header">Footer</h2>
      <TemplateEditor ref="footer" height="200" />
      <h2 class="bussiness-header">Note</h2>
      <TemplateEditor ref="note" height="200" />

      <div class="flex justify-end align-center">
        <Button
          className="button--primary save-template"
          :title="settings && settings.length > 0 ? 'Update' : 'Save'"
          :loader="loading"
          :onClick="saveData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import TemplateEditor from "@/components/TemplateEditor";
import Upload from "@/components/Upload.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import Input from "@/components/Input";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    TemplateEditor,
    Button,
    Input,
    Upload,
    ProgressBar
  },
  data() {
    return {
      id: "",
      progressStatus: false,
      branchData: {
        logoUrl: "",
        branchName: null,
        branchAddress: null,
        email: null,
        phoneNumber: null,
        attachmentId: null
      }
    };
  },
  methods: {
    ...mapActions("bussiness", [
      "addBussinessSettings",
      "updateBranchSettingsList",
      "branchSettingsList"
    ]),
    ...mapActions("auth", ["uploadAttachment"]),
    handleFileUpload(file) {
      this.uploadAttachment({ file: file }).then(() => {
        this.branchData.logoUrl = this.attachmentUrl;
        if (this.uploadProgress > 1) {
          this.progressStatus = true;
        }
        if (this.uploadProgress == 100) {
          setTimeout(() => {
            this.progressStatus = false;
          }, 4000);
        }
      });
    },
    saveData() {
      const template = {
        header: this.$refs.header.editor.getContents(),
        footer: this.$refs.footer.editor.getContents(),
        note: this.$refs.note.editor.getContents(),
        tenantId: this.user?.tenantId,
        name: this.branchData.branchName,
        logoPath: this.branchData.logoUrl,
        attachmentId: this.attachmentId,
        email: this.branchData.email,
        phone_number: this.branchData.phoneNumber
      };
      if (this.settings.length > 0) {
        this.updateBranchSettingsList({
          id: `?id=${this.$route.params.id}`,
          payload: template
        });
      } else {
        this.addBussinessSettings(template).then(() => {
          this.$toasted
            .success("Bussiness settings saved successfully")
            .goAway("3000");
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      settings: "bussiness/settings",
      loading: "loading",
      attachmentUrl: "auth/attachmentUrl",
      attachmentId: "auth/attachmentId",
      uploadProgress: "auth/uploadProgress"
    })
  },
  watch: {
    settings(val) {
      const ref = this.$refs || {};
      const item = val.find(item => item);
      if (item) {
        ref.header.editor.setContents(item.header, "api");
        ref.footer.editor.setContents(item.footer, "api");
        ref.note.editor.setContents(item.note, "api");
        this.id = item.id ? item.id : "";
      }
    }
  },
  async mounted() {
    await this.branchSettingsList(this.$route.params.id).then(() => {
      this.branchData.logoUrl = this.settings[0]?.logoPath;
      this.branchData.phoneNumber = this.settings[0]?.phone_number;
      this.branchData.branchName = this.settings[0]?.name;
      this.branchData.email = this.settings[0]?.email;
    });
  }
};
</script>

<style scoped>
.settings-template {
  padding: 18px 24px 24px;
}

.save-template {
  margin-top: 24px;
}

.bussiness-header {
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 1.4;
  color: var(--ink-900);
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.logo_div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.setting_logo {
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  border: 2px solid var(--line-strong);
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.upload_button {
  margin: 1rem 0;
  border: 1px solid var(--line);
  padding-top: 5px;
  border-radius: 50px;
  box-shadow: var(--shadow-sm);
}

.logoImage {
  max-width: 100%;
  object-fit: cover;
}

@media screen and (max-width: 780px) {
  .settings-template {
    padding: 14px 16px 20px;
  }
}
</style>
